import { render, staticRenderFns } from "./TgSearchBar.vue?vue&type=template&id=c37fea40&"
import script from "./TgSearchBar.vue?vue&type=script&lang=js&"
export * from "./TgSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports